module.exports = "/images/Loggi_v2.svg?f4cc79827cc91a5cb2fc9d651967b5a3";